<template>
  <div class="wrapper">
    <div class="wrapper__menu">
      <ul class="wrapper__menu__wrapper">
        <template v-for="(item, index) in list">
          <li v-if="!item.subitem" :key="index" @click.stop="select(item)"
          class="wrapper__menu__wrapper__item" :class="{selected: isSelected.includes(index)}">
            <span class="subhead">{{ item.label | capitalizing }}</span>
          </li>
          <template v-else>
            <li :key="index" @click.stop="selectDropdown(item, index)"
            class="wrapper__menu__wrapper__item__sub" :class="{selected: isSelected.includes(index)}">
              <span class="subhead">{{ item.label | capitalizing }}</span>
              <i :class="isOpen.includes(index) ? 'icon-chevronup':'icon-chevrondown'" class=" icon-subitem"></i>
            </li>
            <adx-sub-filter @select="selectSub" :parent="item" :key="`i${index}`"
            :subitem="item.subitem" v-if="isOpen.includes(index)" :value="subValue" />
          </template>
        </template>
      </ul>
    </div>
  </div>
</template>

<script>
import SubFilter from '@/components/QuickFilter/SubFilter'

export default {
  name: "adx-quick-filter",
  components: {
    'adx-sub-filter': SubFilter
  },
  props: {
    list: {
      type: Array,
      required: true,
    },
    value: {
      required: false,
      default: ``
    },
    subValue: {
      required: false,
      default: ``
    },
    defaultOpen: {
      required: false,
      default: ``
    }
  },
  data() {
    return {
      isOpen: [],
      isSelected: [0]
    }
  },
  watch: {
    defaultOpen: function() {
      if (this.defaultOpen) {
        this.isOpen.push(this.defaultOpen)
      }
    },
    list: function() {
      this.checkSelected(this.value)
    },
    value: function() {
      if(!this.value) {
        this.isSelected = []
      } else {
        this.checkSelected(this.value)
      }
    }
  },
  mounted(){
    if (this.value){
      this.checkSelected(this.value)
    }
  },
  methods: {
    select(item) {
      this.checkSelected(item.value)
      this.$emit(`update:value`, item.value)
      this.$emit(`valueClicked`, item.value)
    },
    selectSub(item, parent){
      this.checkSelected(item.value)
      this.$emit('selectSub', item, parent)
    },
    dropdown(index) {
      if(this.isOpen.includes(index)){
        const item = this.isOpen.indexOf(index)
        if (item !== -1) this.isOpen.splice(item, 1)
      }else {
        this.isOpen.push(index)
      }
    },
    selectDropdown(item, index) {
      this.select(item)
    },
    checkSelected(value) {
      let isSelected = []
      let isFamilySelected = false
      let key = null
      this.list.forEach(function (item, index) {
        if (item.value == value && !item.subitem) {
          isSelected.push(index)
        } else if (item.subitem) {
          if (item.value != value) {
            item.subitem.forEach(function (subitem) {
              if (subitem.value == value) {
                isFamilySelected = true
              }
            })
          } else {
            isFamilySelected = true
            key = index
          }
        }
      })
      if (!isFamilySelected && this.isOpen.length > 0) {
        this.isOpen = []
      }
      if (key) {
        this.dropdown(key)
      }
      this.isSelected = isSelected
    }
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>